<script setup>
import { computed } from 'vue';

import { formStore } from '@/stores/form.js';

const form = formStore();

// eslint-disable-next-line no-undef
const baseUrl = publicPath + modulePath || import.meta.env.VITE_BASE_URL;
const props = defineProps({
  src: {
    type: String,
    default: null,
  },
});

const logo = computed(() => {
  return props.src ? props.src : `${baseUrl}/logo/alpina_logo.png`;
});
</script>

<template>
  <a :href="form.links['link-diks-nl']">
    <img
      class="img-fluid logo"
      :src="logo"
      alt="Logo"
    >
  </a>
</template>

<style scoped lang="scss">
.logo {
  max-height: 3.7rem;
}
</style>
